import { FloatingWidget } from '@/components/FloatingWidget';
import FloatingWidgetProvider from '@/context/FloatingWidgetContext';
import { Outlet } from 'react-router-dom';

const BaseElement = () => {
  return (
    <div>
      <FloatingWidgetProvider>
        <Outlet />
        <FloatingWidget />
      </FloatingWidgetProvider>
    </div>
  );
};

export default BaseElement;
